import { RECURRING_THEMES } from "@/data/content";
import {
  ClipboardCheck,
  HeartHandshake,
  Hotel,
  BookOpen,
  MessageCircle,
  Users,
  ShieldCheck,
  Sparkles,
  Check,
} from "lucide-react";

const ICONS = {
  "clipboard-check": ClipboardCheck,
  "heart-hand": HeartHandshake,
  hotel: Hotel,
  "book-open": BookOpen,
  "message-circle": MessageCircle,
  users: Users,
  "shield-check": ShieldCheck,
  sparkles: Sparkles,
};

export default function RecurringThemes() {
  return (
    <section
      data-testid="recurring-themes"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <span className="overline">What Pilgrims Consistently Say</span>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl text-[color:var(--maqam-navy)] leading-[1.05] tracking-tight">
            We don't need to make claims.<br />Our pilgrims already do.
          </h2>
          <p className="mt-5 text-[var(--maqam-muted)] leading-relaxed">
            These are the themes that show up in review after review — across trips, cities, and years.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RECURRING_THEMES.map((t, i) => {
            const Icon = ICONS[t.icon] || Check;
            return (
              <article
                key={i}
                data-testid={`theme-${i}`}
                className="review-shadow-hover rounded-2xl border border-[var(--maqam-border)] bg-white p-7 flex flex-col"
              >
                <div className="flex items-center gap-2">
                  <span
                    className="inline-flex w-10 h-10 rounded-full items-center justify-center"
                    style={{ background: "rgba(200,162,74,0.16)" }}
                  >
                    <Icon size={18} className="text-[color:var(--maqam-navy)]" />
                  </span>
                  <Check size={14} className="text-[color:var(--maqam-gold)]" />
                </div>
                <h3 className="mt-5 font-serif text-xl text-[color:var(--maqam-navy)] leading-tight">
                  {t.title}
                </h3>
                <p className="mt-2 text-sm text-[var(--maqam-muted)] leading-relaxed">
                  {t.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
